import type { IconProps } from './icon.types'

// The paretos "arch" brand glyph. Fills with currentColor so it inherits the
// surrounding text colour (black in the topnav, white/translucent on the
// gradient brand pane).
const ParetosMarkIcon = (props: IconProps) => (
  <svg
    viewBox='0 0 190.93 79.76'
    fill='currentColor'
    aria-hidden='true'
    data-testid='paretos-mark-icon'
    {...props}
  >
    <path
      d='M 160.747 0 C 160.084 25.816 138.749 49.521 111.18 49.119 C 83.611 49.521 62.236 25.796 61.612 0 L 0 0 L 0 79.76 L 31.691 79.76 L 31.691 6.796 C 35.15 47.671 69.394 79.76 111.16 79.76 C 155.217 79.76 190.93 44.052 190.93 0 L 160.727 0 L 160.747 0 Z'
      fillRule='nonzero'
    />
  </svg>
)

export default ParetosMarkIcon
